import React, {useEffect} from 'react';
import "./Button.sass";
import {ReactComponent as CheckBox_default} from "../../../icons/check_box_default.svg";
import {ReactComponent as CheckBox_selected} from "../../../icons/check_box_selected.svg";
import {ReactComponent as Radio_default} from "../../../icons/radio_default.svg";
import {ReactComponent as Radio_selected} from "../../../icons/radio_selected.svg";

const Button = React.forwardRef(({data, id, callback, params, type, className, style, disabled, selected}, ref) => {

    const BUTTONTYPE_CHECKBOX = "select";
    const BUTTONTYPE_RADIO = "radio";

    const handleClick = () => {
        callback(params);
    }

    const getIcon = () => {
        let icon = null;
        switch (type) {
            case BUTTONTYPE_CHECKBOX:
                if (selected) {
                    icon = <CheckBox_selected className="checkbox"/>;
                } else {
                    icon = <CheckBox_default className="checkbox"/>;
                }
                break;
            case BUTTONTYPE_RADIO:
                if (selected) {
                    icon = <Radio_selected className="checkbox"/>;
                } else {
                    icon = <Radio_default className="checkbox"/>;
                }
                break;
            default:
                icon = null;
        }
        return icon
    }

    return <div className={"Button " + (className?className:" standard") + (disabled?" disabled":"")}
                style={style || {}}
                onClick={handleClick}>
        {(type == "select") &&
        <div className="checkbox">
            {getIcon()}
        </div>
        }


        {data}
    </div>;
});

export default Button;
